import JSZip from 'jszip';
import FileSaver from 'file-saver';
import {
  formatDurationToHHMMSS,
  formatNumericDateToISOString,
  getDownloadMessagesFileName,
  removeFileExtension
} from '../../common/helpers/common.helpers';
import { DOWNLOAD_ZIP_ERROR, TRANSCRIPTION_FILE_NAME } from '../../constants/constants';

/**
 * Class representing the amazon service.
 * */
class AmazonService {

  /**
   * Fetch files from urls
   * @param {array} files - The list of files.
   * @return {Promise} response - New promise with results as array.
   */
  fetchFiles = (files) => {
    const requests = files.map(file => fetch(file.url || file.download_url)
      .then((response) => {
        if (!response.ok) { throw Error(response.statusText); }
        return {
          data: response.blob(),
          name: file.name
        };
      }));
    return Promise.all(requests);
  }

  /**
   * Archive files
   * @param {array} files - The list of files.
   * @return {Promise<Blob>} archive - The archive as blob.
   */
  archiveFiles = (files) => {
    const zip = new JSZip();

    files.forEach((file) => {
      zip.file(file.name, file.data);
    });

    return zip.generateAsync({ type: 'blob' });
  }

  /**
   * Creates transcription
   * @param {array} files - The list of files.
   * @return {object} transcription - The transcription object.
   */
  createTranscription = (files) => {
    const messages = {
      RecordedMessages: []
    };

    messages.RecordedMessages = files.map(file => ({
      Id: file.id,
      FileName: file.name,
      Label: removeFileExtension(file.name),
      TranscribeFileWhenUploaded: true,
      Transcription: {
        Text: file.transcription,
        Source: 'user',
      },
      Tags: file.tags ? file.tags.map(tag => ({
        Name: tag
      })) : null,
      Length: formatDurationToHHMMSS(file.duration),
      CreatedTime: formatNumericDateToISOString(file.created)
    }));

    return {
      name: TRANSCRIPTION_FILE_NAME,
      data: JSON.stringify(messages, null, 2)
    };
  }

  /**
   * Fetch, zip and download files to browser
   * @param {array} files - The list of files.
   */
  downloadZip = async (files) => {
    try {
      const results = await this.fetchFiles(files);
      results.push(this.createTranscription(files));

      const zip = await this.archiveFiles(results);
      if (zip) {
        FileSaver.saveAs(zip, getDownloadMessagesFileName);
      }
    } catch (error) {
      throw new Error(`${DOWNLOAD_ZIP_ERROR} ${error}`);
    }
  }

}

export default new AmazonService();



// WEBPACK FOOTER //
// ./src/messages/services/amazon.service.js